import { BrowserRouter as Router } from "react-router-dom"

import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"
import { HelmetProvider } from "react-helmet-async"

import "simplebar-react/dist/simplebar.min.css"
// Providers
import { VenueProvider } from "./providers/venue"
import { AppUIProvider } from "./providers/ui"
import { RouteProvider } from "./providers/route/RouteProvider"
import { GeoLocationProvider } from "./providers/geolocation"

import { FallbackError } from "components/error/FallbackError"

import config from "./config"
import { StandardApp } from "./StandardApp"
import { KioskHApp } from "./KioskHApp"

Sentry.init({
  enabled: process.env.NODE_ENV === "production",
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
})

/** NOTE: IIFE Self-Invoking Functions
 * คือการประกาศ function แล้วเรียกใช้ทันที
 *
 * (() => {
 *   ....
 * })()
 *
 */

const VenueApp = (() => {
  switch (config("device")) {
    case "kiosk-h":
      return KioskHApp
    case "kiosk-v":
    case "mobile":
    default:
      return StandardApp
  }
})()

function Main() {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackError />}>
      <HelmetProvider>
        <VenueProvider>
          <RouteProvider>
            <Router>
              <AppUIProvider>
                <GeoLocationProvider>
                  <VenueApp />
                </GeoLocationProvider>
              </AppUIProvider>
            </Router>
          </RouteProvider>
        </VenueProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  )
}

export default Main
